<header class="header">
  <div class="container">
    <div class="header__inner">
      <div class="header__content">
        <a href="" class="header__logo"><img src="/assets/image/beastborne.png" alt="BeastBorne"></a>
        <nav class="header__menu menu hide">
          <ul>
            <li><a class="header__menu-link" [routerLink]="['/', lang, 'index']"
                routerLinkActive="active">{{'header.menu.dashboard' | translate}}</a></li>
            <li><a class="header__menu-link" [routerLink]="['/', lang, 'marketplace']"
                routerLinkActive="active">{{'header.menu.marketplace' | translate}}</a></li>
            <li><a class="header__menu-link">
                <span b-y12tpbi3pz="" class="coming-soon-icon">{{'header.menu.coming_soon' | translate}}</span>
                {{'header.menu.games' | translate}}
              </a>
            </li>
          </ul>
          <div class="header__data">
            @if(!isWalletConnected){
            <button class="header__connect" [routerLink]="['/', lang, 'connect-wallet']"
              routerLinkActive="active">{{'header.menu.connect_wallet' | translate}}</button>
            } @else {
            <a class="header__menu-link disabled" *ngIf="false" [routerLink]="['/', lang, 'rent-creatures']"
              routerLinkActive="active">{{'header.menu.rent_creature' | translate}}</a>
            <a class="header__menu-link" [routerLink]="['/', lang, 'my-creatures']"
              routerLinkActive="active">{{'header.menu.my_creatures' | translate}}</a>
            <button class="header__connect" routerLinkActive="active">{{walletAddress}}</button>

            <div class="header__notice"
              [ngClass]="{'active': showNotificationCenter, 'has-new': newNotificationCount > 0}"
              (click)="openNotificationCenter()">
              <button class="header__notice-btn">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9 1V1.625C11.2812 2.09375 13 4.09375 13 6.5V7.09375C13 8.5625 13.5312 10 14.5 11.0938L14.7188 11.3438C15 11.6562 15.0625 12.0625 14.9062 12.4375C14.75 12.7812 14.375 13 14 13H2C1.59375 13 1.21875 12.7812 1.0625 12.4375C0.90625 12.0625 0.96875 11.6562 1.25 11.3438L1.46875 11.0938C2.4375 10 3 8.5625 3 7.09375V6.5C3 4.09375 4.6875 2.09375 7 1.625V1C7 0.46875 7.4375 0 8 0C8.53125 0 9 0.46875 9 1ZM8 16C7.46875 16 6.9375 15.8125 6.5625 15.4375C6.1875 15.0625 6 14.5312 6 14H10C10 14.5312 9.78125 15.0625 9.40625 15.4375C9.03125 15.8125 8.5 16 8 16Z"
                    fill="white" />
                </svg>
              </button>
              <div class="header__notice-block">
                <h3 class="header__notice-title">Notifications</h3>
                <div class="header__notice-scroll">
                  <div class="header__notice-list">
                    <div class="header__notice-item" *ngFor="let item of notifications">
                      <div class="header__notice-left">
                        <div class="header__notice-img"
                          *ngIf="item.type == notificationType.CreateTradeListing || item.type == notificationType.ModifyTradeListing || item.type == notificationType.CreatureIsBought || item.type == notificationType.CreatureIsSold || item.type == notificationType.TradeListingError">
                          <img *ngIf="item.creature" [src]="item.creature.imageUrl" alt="Moonbit">
                        </div>
                        <div class="header__notice-info">
                          <div class="header__notice-name"
                            *ngIf="item.type == notificationType.CreateTradeListing || item.type == notificationType.ModifyTradeListing || item.type == notificationType.CreatureIsBought || item.type == notificationType.CreatureIsSold">
                            <span>#{{item.creature?.nftTokenId}}</span> {{'notification.messages.' + item.message! | translate}}
                          </div>
                          <div class="header__notice-name"
                            style="color: red;"
                            *ngIf="item.type == notificationType.TradeListingError">
                            <span>#{{item.creature?.nftTokenId}}</span> {{'notification.messages.' + item.message! | translate}} <br>
                            <span style="color: red;" style="font-size: 12px;">{{item.params['error_message']}}</span>
                          </div>
                          <div class="header__notice-name" *ngIf="item.type == notificationType.BreedingIsReady">{{'notification.messages.' + item.message! | translate}}</div>
                          <div class="header__notice-time">{{item.createdAt | timeAgo}}</div>
                        </div>
                      </div>
                      <div class="header__notice-right" *ngIf="item.amountInEth">
                        <div class="header__notice-point">{{item.amountInEth}} ETH</div>
                        <div class="header__notice-price">{{item.amountInEth! | ethPrice}} USD</div>
                      </div>
                      <div class="header__notice-right" *ngIf="item.continueBreedingLink">
                        <a [routerLink]="'/' + lang + item.continueBreedingLink">Open</a>
                      </div>
                    </div>
                    <!-- <div class="header__notice-item">
                      <div class="header__notice-left">
                        <div class="header__notice-img">
                          <img src="/assets/image/List/person1.png" alt="Moonbit">
                        </div>
                        <div class="header__notice-info">
                          <div class="header__notice-name"><span>#1452</span> creature was sold</div>
                          <div class="header__notice-time">8 hours ago</div>
                        </div>
                      </div>
                    </div>
                    <div class="header__notice-item">
                      <div class="header__notice-left">
                        <div class="header__notice-img">
                          <img src="/assets/image/List/person1.png" alt="Moonbit">
                        </div>
                        <div class="header__notice-info">
                          <div class="header__notice-name"><span>#1452</span> creature was sold</div>
                          <div class="header__notice-time">8 hours ago</div>
                        </div>
                      </div>
                    </div>
                    <div class="header__notice-item">
                      <div class="header__notice-left">
                        <div class="header__notice-img">
                          <img src="/assets/image/List/person1.png" alt="Moonbit">
                        </div>
                        <div class="header__notice-info">
                          <div class="header__notice-name"><span>#1452</span> creature was sold</div>
                          <div class="header__notice-time">8 hours ago</div>
                        </div>
                      </div>
                    </div>
                    <div class="header__notice-item">
                      <div class="header__notice-left">
                        <div class="header__notice-img">
                          <img src="/assets/image/List/person1.png" alt="Moonbit">
                        </div>
                        <div class="header__notice-info">
                          <div class="header__notice-name"><span>#1452</span> creature was sold</div>
                          <div class="header__notice-time">8 hours ago</div>
                        </div>
                      </div>
                    </div>
                    <div class="header__notice-item">
                      <div class="header__notice-left">
                        <div class="header__notice-img">
                          <img src="/assets/image/List/person1.png" alt="Moonbit">
                        </div>
                        <div class="header__notice-info">
                          <div class="header__notice-name"><span>#1452</span> creature was sold</div>
                          <div class="header__notice-time">8 hours ago</div>
                        </div>
                      </div>
                    </div>
                    <div class="header__notice-item">
                      <div class="header__notice-left">
                        <div class="header__notice-img">
                          <img src="/assets/image/List/person1.png" alt="Moonbit">
                        </div>
                        <div class="header__notice-info">
                          <div class="header__notice-name"><span>#1452</span> creature was sold</div>
                          <div class="header__notice-time">8 hours ago</div>
                        </div>
                      </div>
                    </div>
                    <div class="header__notice-item">
                      <div class="header__notice-left">
                        <div class="header__notice-img">
                          <img src="/assets/image/List/person1.png" alt="Moonbit">
                        </div>
                        <div class="header__notice-info">
                          <div class="header__notice-name"><span>#1452</span> creature was sold</div>
                          <div class="header__notice-time">8 hours ago</div>
                        </div>
                      </div>
                    </div>
                    <div class="header__notice-item">
                      <div class="header__notice-left">
                        <div class="header__notice-img">
                          <img src="/assets/image/List/person1.png" alt="Moonbit">
                        </div>
                        <div class="header__notice-info">
                          <div class="header__notice-name"><span>#1452</span> creature was sold</div>
                          <div class="header__notice-time">8 hours ago</div>
                        </div>
                      </div>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
            }
            <div class="header__search">
              <button class="header__search-btn">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M16.625 14.875C17.0938 15.375 17.0938 16.1562 16.625 16.6562C16.125 17.125 15.3438 17.125 14.8438 16.6562L11.125 12.9062C9.84375 13.75 8.28125 14.1875 6.59375 13.9688C3.71875 13.5625 1.40625 11.2188 1.03125 8.375C0.5 4.125 4.09375 0.53125 8.34375 1.0625C11.1875 1.4375 13.5312 3.75 13.9375 6.625C14.1562 8.3125 13.7188 9.875 12.875 11.125L16.625 14.875ZM3.46875 7.5C3.46875 9.71875 5.25 11.5 7.46875 11.5C9.65625 11.5 11.4688 9.71875 11.4688 7.5C11.4688 5.3125 9.65625 3.5 7.46875 3.5C5.25 3.5 3.46875 5.3125 3.46875 7.5Z"
                    fill="white" />
                </svg>
              </button>
              <input type="text" class="header__search-input" placeholder="Search ...">
            </div>
            <select class="custom-select__trigger custom-select__dropdown" [(ngModel)]="lang"
              (change)="onChangeLanguage($event)" name="durationInDays">
              <option [value]="'en'">English </option>
              <option [value]="'ja'">日本語</option>
              <option [value]="'ko'">한국의</option>
              <option [value]="'zh'">中文</option>
              <option [value]="'ms'">Bahasa Melayu</option>
              <option [value]="'vi'">Tiếng Việt</option>
            </select>
          </div>
        </nav>
      </div>

      <button class="menu-toggle">
        <div class="menu-toggle__items">
          <span class="menu-toggle__item"></span>
          <span class="menu-toggle__item"></span>
          <span class="menu-toggle__item"></span>
        </div>
      </button>
    </div>
  </div>
</header>